import React from 'react';
import './PC.css';
import Bernardo from '../../img/speakers/Bernardo.png'
import BRASSLION from '../../img/speakers/BRASS LION.png'
import Carucci from '../../img/speakers/Carucci.png'
import Diaz from '../../img/speakers/Diaz.png'
import Edwards from '../../img/speakers/Edwards.png'
import ElectronicArts from '../../img/speakers/ElectronicArts.png'
import Geogrify from '../../img/speakers/Geogrify.png'
import Gómez from '../../img/speakers/Gómez.png'
import Google from '../../img/speakers/Google.png'
import Leducq from '../../img/speakers/Leducq.png'
import PlayStar from '../../img/speakers/PlayStar.png'
import Rocketwerkz from '../../img/speakers/Rocketwerkz.png'
import Mittner from '../../img/speakers/Mittner.png'
import TinyHyndra from '../../img/speakers/TinyHyndra.png'
import Klingsbo from '../../img/speakers/Klingsbo.png'
import Flame from '../../img/speakers/Flame.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Diaz,
          name: 'John R. Diaz',
          position: 'Senior Technical Game Designer',
          ln: 'https://www.linkedin.com/in/jkingpin/',
          tw: 'https://twitter.com/ElKingpin',
          website: 'https://linktr.ee/JKingpin',
          logo: ElectronicArts,
        },
        {
          photo: Gómez,
          name: 'Elaine Gómez',
          position: 'Game Designer',
          ln: 'https://www.linkedin.com/in/elaine-g%C3%B3mez/',
          tw: 'https://twitter.com/chulatastic',
          logo: BRASSLION,
        },
        {
          photo: Leducq,
          name: 'Carl Leducq',
          position: 'Production Coordinator',
          ln: 'https://www.linkedin.com/in/carlleducq/',
          tw: 'https://twitter.com/carlscontent',
          logo: Rocketwerkz,
        },
        {
          photo: Klingsbo,
          name: 'Lukas Klingsbo',
          position: 'Developer',
          github: 'https://github.com/spydon',
          logo: Flame,
        },
        {
          photo: Carucci,
          name: 'Francesco Carucci',
          position: 'Senior Game Developers Advocate',
          ln: 'https://www.linkedin.com/in/fcarucci/',
          tw: 'https://twitter.com/fcarucci',
          logo: Google,
        },
        {
          photo: Bernardo,
          name: 'Dan Bernardo',
          position: 'Co-Founder and Director',
          ln: 'https://www.linkedin.com/in/danbesaints/',
          tw: 'https://twitter.com/Danbesaints',
          logo: PlayStar,
        },
        {
          photo: Edwards,
          name: 'Kate Edwards',
          position: 'CEO',
          ln: 'https://www.linkedin.com/in/geogrify/',
          tw: 'https://twitter.com/geogrify',
          logo: Geogrify,
        },
        {
          photo: Mittner,
          name: 'Martin Mittner',
          position: 'CEO',
          ln: 'https://www.linkedin.com/in/mmittner/',
          logo: TinyHyndra,
        },
      ],
      isHovered: false,
      hoveredPC: [],
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter = (name) => {
    this.setState({ isHovered: true })
    if (this.state.hoveredPC.indexOf(name) > -1) {
      let index = this.state.hoveredPC.indexOf(name);
      if (index !== -1) {
        this.setState({
          hoveredPC: this.state.hoveredPC.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hoveredPC: [...this.state.hoveredPC, name] })
    }
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
    this.setState({ hoveredPC: [] });
  };

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Speakers from previous events</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}